/** Insights API endpoints, merged into the platform API client. */
export const insightsApiEndpoints: Record<string, string> = {
  moreInsights: "/ext/insights/projects/:pk/",
};
